import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { loginUser } from '../models/Users'
import { getMessage } from '../helpers/Messages'
import Loading from '../components/loaders/PageLoader'
import { dialogState } from '../system/redux/reducers/dialog'

const LoginForm = ({ dispatch, message }) => {
    const [loading, setLoading] = useState(false)
    const { register, handleSubmit, formState: { errors }} = useForm()
    const [details, setDetails] = useState({})
    const handleChange = (e, type) => {
        setDetails({ ...details, [type]: e.target.value })
    }
    const submitFunction = () => {
        setLoading(true)
        const { email, password } = details
        loginUser(dispatch, { email, password }).then(() => {
            setLoading(false)
            dispatch(dialogState(JSON.stringify({ open: false, id: '' })))
        })
    }
    return (
        <Box component="form" onSubmit={handleSubmit(() => {
            submitFunction()
        })}>
            <Grid pt={4} container='true' variant='container'>
                <Grid item xs={12} mb={errors && errors.email ? 1 : 2}>
                    <TextField
                        {...register(
                            'email',
                            { required: 'Cannot be empty', pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: getMessage('formEmailInvalid'),
                            }})}
                        fullWidth
                        autoComplete='off'
                        onChange={(e) => handleChange(e, 'email')}
                        type='text'
                        name='email'
                        placeholder='Email'
                    />
                    { errors && errors.email && <Box fontSize='12px' color='red.main'>{errors.email.message}</Box> }
                </Grid>
                <Grid item xs={12} mt={errors && errors.email ? 1 : 2} mb={errors && errors.password ? 1 : 2}>
                    <TextField
                        {...register('password', { required: 'Cannot be empty', pattern: {
                            value: /.{6,}/i,
                            message: getMessage('formPasswordInvalid'),
                        }})}
                        fullWidth
                        autoComplete='new-password'
                        onChange={(e) => handleChange(e, 'password')}
                        type='password'
                        placeholder='Password'
                    />
                </Grid>
                {
                    errors && errors.password ?
                        <Grid mb={2} item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography color='blue.main' fontSize='12px' fontWeight='bold'>{errors.password.message}</Typography>
                        </Grid> :
                        null
                }
                {
                    message ?
                        <Grid mb={2} item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography color='blue.main' fontSize='12px' fontWeight='bold'>{message}</Typography>
                        </Grid> :
                        null
                }
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    {
                        !loading ?
                            <>
                                <Button mt='md' type='submit'>Login</Button>
                            </> :
                            <Loading />
                    }

                </Grid>
            </Grid>
        </Box>
    )
}
function mapStateToProps(state) {
    return {
        errors: state.Auth.errors,
        message: state.User.message,
    }
}
export default connect(mapStateToProps)(LoginForm)
